<template>
  <avs-button
    v-bind="{ ...$attrs }"
    v-on="{ ...$listeners }"
    color="accent"
    iconI="mdi-export"
    :menu="menu"
    :spantext="spantext"
    text
    @click="handleExport()"
  >
    <template v-slot:name>
      {{ name }}
    </template>
  </avs-button>
</template>

<script>
import { handleExportCSV } from "@/utils/download"

export default {
  name: "ExportButton",
  props: {
    data: { type: Array, required: false, default: null },
    format: { type: String, default: "csv" },
    prepare: { type: Function, default: null },
    menu: {
      type: Boolean,
      default: false
    },
    name: {
      type: String
    },
    spantext: {
      type: String
    }
  },
  methods: {
    handleExport() {
      if (this.data && this.data.length > 0) {
        const data = this.prepare !== null ? this.prepare(this.data) : this.data
        handleExportCSV([data], this.format)
      }
    }
  }
}
</script>
